import type { Grade } from '@backmarket/http-api/src/api-models/Grade'

/**
 * Canonical backbox grade labels used by the reviews service, ordered from
 * best condition to most economical. Matches the ordering exposed in the
 * reviews UI grade filter (`useGradeFilter`).
 *
 * @see {@link https://devportal.backmarket.io/catalog/default/api/review-service-api/definition#tag/product/operation/get-reviews-products-id-reviews}
 */
export const BACKBOX_GRADE_LABELS = [
  'PREMIUM',
  'FLAWLESS',
  'VERY_GOOD',
  'ECO',
] as const satisfies Grade['name'][]

export type BackboxGradeLabel = (typeof BACKBOX_GRADE_LABELS)[number]

/**
 * Minimum global rate a review must have to be eligible for the per-grade
 * aggregation. Keeps low-quality reviews out of the curated picture set.
 */
export const MIN_RATE = 3.0

/**
 * Page size requested when fetching reviews for the per-grade aggregation.
 */
export const PAGE_SIZE = 20
